import { render, staticRenderFns } from "./TransferirModal.vue?vue&type=template&id=0cc132a0&"
import script from "./TransferirModal.vue?vue&type=script&lang=js&"
export * from "./TransferirModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/gestao-aprovacao/TransferirModal.vue
// module id = 1406
// module chunks = 28